"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _connectedReactRouter = require("connected-react-router");

var _defaultGift = require("../../store/campaign/defaultGift/defaultGift.actions");

var _campaigns = require("../../store/entities/campaigns/campaigns.actions");

var _defaultGift2 = require("../../store/campaign/defaultGift/defaultGift.selectors");

var _campaigns2 = require("../../store/entities/campaigns/campaigns.selectors");

var _useGetCampaignId = require("../../hooks/useGetCampaignId");

var _routePathes = require("../../routePathes");

var _sendAsPerson = require("../../store/campaign/sendAsPerson/sendAsPerson.actions");

var _campaign = require("../../store/campaign/campaign.actions");

var _recipient = require("../../store/recipient/recipient.actions");

var _sendAsPerson2 = require("../../store/campaign/sendAsPerson/sendAsPerson.selectors");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      breakpoints = _ref.breakpoints;
  return {
    campaignSelect: {
      width: 350,
      marginTop: spacing(3)
    },
    popper: {
      minWidth: 380,
      [breakpoints.down('xs')]: {
        minWidth: 330
      },
      '& .MuiAutocomplete-option': {
        minHeight: 32
      }
    },
    optionContainer: {
      display: 'flex',
      width: '100%',
      paddingTop: 0
    },
    optionLabel: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    giftImage: {
      width: 260,
      minHeight: 150,
      color: palette.common.white,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: "1px solid ".concat(palette.common.white),
      borderRadius: 5
    },
    skeleton: {
      backgroundColor: palette.grey.chambray50
    },
    sendAsSkeleton: {
      backgroundColor: palette.grey.chambray50,
      display: 'inline-block',
      marginLeft: spacing(1)
    },
    valueLabel: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    value: {
      color: palette.text.primary
    }
  };
});
var defaultOption = {
  label: 'Select campaign'
};

var SelectCampaignStep = function SelectCampaignStep() {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var campaigns = (0, _reactRedux.useSelector)(_campaigns2.getCampaigns);
  var isCampaignsLoading = (0, _reactRedux.useSelector)(_campaigns2.getIsLoading);
  var campaignId = (0, _useGetCampaignId.useGetCampaignId)();
  var defaultGift = (0, _reactRedux.useSelector)(_defaultGift2.getDefaultGift);
  var isDefaultGiftLoading = (0, _reactRedux.useSelector)(_defaultGift2.getIsDefaultGiftLoading);
  var sendAsPerson = (0, _reactRedux.useSelector)(_sendAsPerson2.getSendAsPerson);
  var isSendAsLoading = (0, _reactRedux.useSelector)(_sendAsPerson2.getSendAsPersonIsLoading);
  var isDefaultGiftVisible = defaultGift || isDefaultGiftLoading;
  var isSendAsVisible = sendAsPerson || isSendAsLoading;
  var giftCardPrice = defaultGift && defaultGift.denomination ? "".concat(defaultGift.denomination.currencySign).concat(defaultGift.denomination.amount, " ") : '';
  (0, _react.useEffect)(function () {
    dispatch((0, _campaigns.loadCampaigns)());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    if (campaignId) {
      dispatch((0, _defaultGift.loadCampaignDefaultGift)({
        campaignId
      }));
      dispatch((0, _sendAsPerson.loadCampaignSendAsPerson)({
        campaignId
      }));
      dispatch((0, _recipient.resetRecipient)());
    } else {
      dispatch((0, _campaign.reset)());
    }
  }, [dispatch, campaignId]);
  var handleSelectCampaign = (0, _react.useCallback)(function (option) {
    if (!option) {
      return;
    }

    dispatch((0, _connectedReactRouter.push)(_routePathes.GIFTING_ON_THE_FLY_ROUTES.buildCampaignPath(option.id)));
  }, [dispatch]);
  var options = (0, _react.useMemo)(function () {
    return campaigns.map(function (campaign) {
      return {
        id: campaign.id,
        label: campaign.name
      };
    });
  }, [campaigns]);
  var selectedOption = (0, _react.useMemo)(function () {
    return options.find(function (_ref2) {
      var id = _ref2.id;
      return id === campaignId;
    }) || defaultOption;
  }, [options, campaignId]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White-Bold"
  }, "Step 1: Select Campaign"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.MultiAutocomplete, {
    label: "campaigns",
    name: "Campaign",
    value: selectedOption,
    options: options,
    loading: isCampaignsLoading,
    onChange: handleSelectCampaign,
    classes: classes,
    listboxProps: {
      rowHeight: 32,
      maxVisibleRows: 10
    },
    getOptionLabel: function getOptionLabel(option) {
      var _option$label;

      return (_option$label = option === null || option === void 0 ? void 0 : option.label) !== null && _option$label !== void 0 ? _option$label : '';
    },
    getOptionSelected: function getOptionSelected(option, optionValue) {
      return option.id === optionValue.id;
    },
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, props, {
        key: option.id
      }), /*#__PURE__*/_react.default.createElement(_material.Box, {
        pt: "6px",
        "data-testid": "GiftingOnTheFly.CampaignSelect.".concat(option.id),
        className: classes.optionContainer
      }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
        title: option.label,
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: classes.optionLabel
      }, option.label))));
    },
    renderValue: function renderValue(option) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: classes.value
      }, option === null || option === void 0 ? void 0 : option.label);
    },
    multiple: false
  })), isSendAsVisible && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White"
  }, "Gift Attribution:", ' ', sendAsPerson && !isSendAsLoading && /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "GiftingOnTheFly.SendAsPerson"
  }, "".concat(sendAsPerson.firstName, " ").concat(sendAsPerson.lastName)), isSendAsLoading && /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 100,
    height: 26,
    className: classes.sendAsSkeleton
  }))), isDefaultGiftVisible && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White"
  }, "Leading Gift:")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    className: classes.giftImage
  }, defaultGift && !isDefaultGiftLoading && /*#__PURE__*/_react.default.createElement(_ui.MarketplaceProductImage, {
    src: defaultGift.image
  }), isDefaultGiftLoading && /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "rectangular",
    width: "100%",
    height: 220,
    className: classes.skeleton
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White-Bold"
  }, defaultGift && !isDefaultGiftLoading && /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "GiftingOnTheFly.DefaultGift.Name"
  }, "".concat(giftCardPrice).concat(defaultGift.name)), isDefaultGiftLoading && /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 200,
    height: 26,
    className: classes.skeleton
  })))));
};

var _default = /*#__PURE__*/(0, _react.memo)(SelectCampaignStep);

exports.default = _default;